import request from "@/utils/request.js"
// 获取全局配置
export function get_config(data){
  return request({
    	  method:'GET',
    	  url:'/home/get_config',
    	  params:data
    })
}
// 获取底部备案信息配置
export function get_bottom_record_config(data){
  return request({
    	  method:'GET',
    	  url:'/home/get_page_bottom_text',
    	  params:data
    })
}
// 下载验证
export function check_cy_pwd_api(data){
  return request({
    	  method:'GET',
    	  url:'/home/check_cy_pwd',
    	  params:data
    })
}
// 下载验证密码
export function check_cy_popup_api(data){
  return request({
    	  method:'POST',
    	  url:'/home/check_cy_popup',
    	  params:data
    })
}